import { ReactComponent as EditIcon } from "assets/images/icons/btn_edit.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin.svg";
import { ReactComponent as RemoveHoverIcon } from "assets/images/icons/icn_btn_bin_hover.svg";
import PreviewIcon from "assets/images/icons/icn_table_cell_ViewAll.png";

import React, { useState } from "react";
import { Box, Divider } from "@mui/material";
import EllipsisTooltipCell from "utils/ellipsisTooltipCell";

const ActionIcons = ({
  rowData,
  showEditGeneral,
  onEdit,
  onRemove,
}) => {
  const [isRemoveHovered, setIsRemoveHovered] = useState(false);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <EditIcon
        onClick={(event) => {
          event.stopPropagation();
          onEdit(rowData);
        }}
        style={{ cursor: "pointer", margin: "0 6px 0 2px", width: "18px", height: "18px" }}
      />
      {showEditGeneral && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "primary.greyThread",
              height: "20px",
              width: "1px",
              margin: "0 10px",
            }}
          />
          <Box
            onMouseEnter={() => setIsRemoveHovered(true)}
            onMouseLeave={() => setIsRemoveHovered(false)}
            onClick={(event) => {
              event.stopPropagation();
              onRemove(rowData);
            }}
            sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {isRemoveHovered ? (
              <RemoveHoverIcon style={{ width: "20px", height: "20px", margin: "0 6px 0 2px" }} />
            ) : (
              <RemoveIcon style={{ width: "20px", height: "20px", margin: "0 6px 0 2px" }} />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export const getScheduleTableColumns = ({
  columnHelper,
  showEditGeneral,
  onPreview,
  onPreviewLeave,
  onEdit,
  onRemove,
}) => [
  columnHelper.accessor("name", {
    header: "Schedule Profile Name",
    cell: (info) => (
      <EllipsisTooltipCell text={info.getValue()} />
    ),
  }),
  columnHelper.display({
    id: "preview",
    header: "Preview",
    cell: (info) => {
      const rowData = info.row.original;

      return (
        <img
          src={PreviewIcon}
          alt="View"
          onPointerEnter={(event) => onPreview(rowData, event.currentTarget)}
          onPointerLeave={onPreviewLeave}
          onClick={(event) => {
            event.stopPropagation();
            onPreview(rowData, event.currentTarget);
          }}
          style={{ cursor: "pointer", width: "20px", height: "20px" }}
        />
      );
    },
  }),
  columnHelper.display({
    id: "action",
    header: "Action",
    meta: { isAction: true },
    cell: (info) => (
      <ActionIcons
        rowData={info.row.original}
        showEditGeneral={showEditGeneral}
        onEdit={onEdit}
        onRemove={onRemove}
      />
    ),
  }),
];
